import { QueryClient } from '@tanstack/react-query';

/**
 * React Query client with sane defaults for master-data queries.
 * Mutations are never retried automatically — call sites decide.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30 s
      gcTime: 5 * 60_000, // 5 min
      retry: (failureCount, error) => {
        // Don't retry 4xx
        const status = (error as { response?: { status?: number } })?.response?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});